import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { NavbarComponent } from './navbar/navbar.component';
import { FlexLayoutModule } from '@angular/flex-layout';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatMenuModule } from '@angular/material/menu';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatSidenavModule} from '@angular/material/sidenav';

@NgModule({
    declarations: [
        HeaderComponent,
        FooterComponent,
        NavbarComponent
    ],
    imports: [
        CommonModule,
        FlexLayoutModule,
        RouterModule,
        FormsModule,
        ReactiveFormsModule,
        MatToolbarModule,
        MatMenuModule,
        MatExpansionModule,
        MatSidenavModule
    ],
    exports: [FooterComponent, HeaderComponent],
})
export class LayoutModule {}
